import DOMPurify from "dompurify";

/**
 * Sanitize an HTML string using DOMPurify to prevent XSS attacks.
 * Only allows safe inline formatting tags by default.
 */
export const sanitizeHtml = (dirty: string): string =>
  DOMPurify.sanitize(dirty, {
    ALLOWED_ATTR: ["href", "target", "rel", "class"],
    ALLOWED_TAGS: [
      "b",
      "i",
      "em",
      "strong",
      "a",
      "p",
      "br",
      "ul",
      "ol",
      "li",
      "span",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "blockquote",
      "pre",
      "code",
    ],
  });
